'use client';

import { c as _c } from "react/compiler-runtime";
import * as Dialog from '@radix-ui/react-dialog';
import Image from 'next/image';
import { useRef } from 'react';
import { useConsultation } from '@/app/cc/_apis/consultation/useConsultation';
import Text from '@/app/cc/_component/ui/common/Text/Text';
import { useConsultationFormState } from '@/app/cc/_hooks/consultation/useConsultationFormState';
import { useConsultationPrivacySheet } from '@/app/cc/_hooks/consultation/useConsultationPrivacySheet';
import { sendGA } from '@/app/cc/_util/sendGA';
import { validatePhone } from '@/app/cc/_util/validation';
import { useKind } from '@/app/cc/KindContext';
import ConsultationForm from './ConsultationForm';
import styles from './ConsultationModal.module.scss';
interface ConsultationModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
}
function ConsultationModal(t0) {
  const $ = _c(48);
  const {
    isOpen,
    onClose
  } = t0;
  const isClosingRef = useRef(false);
  const kind = useKind();
  let t1;
  if ($[0] !== onClose) {
    t1 = () => {
      if (isClosingRef.current) {
        return;
      }
      isClosingRef.current = true;
      onClose();
    };
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClose = t1;
  const {
    form,
    setCounselingTime,
    setName,
    setPhone,
    setContractFlag,
    setPrivacyUseFlag,
    setPrivacyProvideFlag
  } = useConsultationFormState(kind);
  let t2;
  if ($[2] !== setPrivacyUseFlag) {
    t2 = () => setPrivacyUseFlag(true);
    $[2] = setPrivacyUseFlag;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== setPrivacyProvideFlag) {
    t3 = () => setPrivacyProvideFlag(true);
    $[4] = setPrivacyProvideFlag;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = {
      onAgreePrivacyUse: t2,
      onAgreePrivacyProvide: t3
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    openPrivacyUseSheet,
    openPrivacyProvideSheet
  } = useConsultationPrivacySheet(t4);
  let t5;
  if ($[9] !== form || $[10] !== handleClose) {
    t5 = {
      onClose: handleClose,
      formData: form
    };
    $[9] = form;
    $[10] = handleClose;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const {
    mutate: postReservation,
    isPending: isLoadingPostReservation
  } = useConsultation(t5);
  let t6;
  if ($[12] !== form.name || $[13] !== form.phone || $[14] !== form.privacyProvideFlag || $[15] !== form.privacyUseFlag || $[16] !== isLoadingPostReservation) {
    t6 = !form.privacyUseFlag || !form.privacyProvideFlag || form.name === "" || !validatePhone(form.phone) || isLoadingPostReservation;
    $[12] = form.name;
    $[13] = form.phone;
    $[14] = form.privacyProvideFlag;
    $[15] = form.privacyUseFlag;
    $[16] = isLoadingPostReservation;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const isSubmitDisabled = t6;
  let t7;
  if ($[18] !== handleClose) {
    t7 = open => !open && handleClose();
    $[18] = handleClose;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Dialog.Overlay className={styles.overlay} />;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div />;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Dialog.Title asChild={true}><Text as="h3" category="title" variant="b2" color="var(--color-gray-900)">상담 예약하기</Text></Dialog.Title>;
    t11 = <Dialog.Description className="sr-only">상담 예약 신청 폼입니다.</Dialog.Description>;
    $[22] = t10;
    $[23] = t11;
  } else {
    t10 = $[22];
    t11 = $[23];
  }
  let t12;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className={styles.titleContent}>{t9}{t10}{t11}<Dialog.Close asChild={true}><button type="button" className={styles.closeButton}><Image src="/cc/image/icon_X.svg" alt="close" fill={true} /></button></Dialog.Close></div>;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== form || $[26] !== openPrivacyProvideSheet || $[27] !== openPrivacyUseSheet || $[28] !== setContractFlag || $[29] !== setCounselingTime || $[30] !== setName || $[31] !== setPhone || $[32] !== setPrivacyProvideFlag || $[33] !== setPrivacyUseFlag) {
    t13 = <ConsultationForm form={form} onCounselingTimeChange={setCounselingTime} onNameChange={setName} onPhoneChange={setPhone} onContractFlagChange={setContractFlag} onPrivacyUseFlagChange={setPrivacyUseFlag} onPrivacyProvideFlagChange={setPrivacyProvideFlag} onOpenPrivacyUseSheet={openPrivacyUseSheet} onOpenPrivacyProvideSheet={openPrivacyProvideSheet} />;
    $[25] = form;
    $[26] = openPrivacyProvideSheet;
    $[27] = openPrivacyUseSheet;
    $[28] = setContractFlag;
    $[29] = setCounselingTime;
    $[30] = setName;
    $[31] = setPhone;
    $[32] = setPrivacyProvideFlag;
    $[33] = setPrivacyUseFlag;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== postReservation) {
    t14 = () => {
      sendGA("reserveClick");
      postReservation();
    };
    $[35] = postReservation;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  const t15 = isLoadingPostReservation ? "\uC0C1\uB2F4 \uC2E0\uCCAD \uC911..." : "\uC0C1\uB2F4 \uC2E0\uCCAD";
  let t16;
  if ($[37] !== isSubmitDisabled || $[38] !== t14 || $[39] !== t15) {
    t16 = <div className={styles.buttonContent}><button type="button" className={styles.confirmButton} disabled={isSubmitDisabled} onClick={t14}>{t15}</button></div>;
    $[37] = isSubmitDisabled;
    $[38] = t14;
    $[39] = t15;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== t13 || $[42] !== t16) {
    t17 = <Dialog.Portal>{t8}<Dialog.Content className={styles.content} onPointerDownOutside={_temp} onInteractOutside={_temp2}>{t12}{t13}{t16}</Dialog.Content></Dialog.Portal>;
    $[41] = t13;
    $[42] = t16;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== isOpen || $[45] !== t17 || $[46] !== t7) {
    t18 = <Dialog.Root open={isOpen} onOpenChange={t7}>{t17}</Dialog.Root>;
    $[44] = isOpen;
    $[45] = t17;
    $[46] = t7;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  return t18;
}
function _temp2(e_0) {
  return e_0.preventDefault();
}
function _temp(e) {
  return e.preventDefault();
}
export default ConsultationModal;